import type { TerritoryChipsFilterOptions } from 'components/TerritoryChipsFilter/types'
import { UserStore } from 'stores'

import getAudienceFromUrl from '../getAudienceFromUrl'

export default function getTerritoryFiltersFromUrl(search: string): TerritoryChipsFilterOptions {
  const searchParams = new URLSearchParams(search)

  const userLanguages = UserStore.userLanguageOptions.filter(language => !language.disabled)

  const categoriesValue = searchParams.get('categories')
  const dateRangeValue = searchParams.get('dateRange')
  const territoryTypesValue = searchParams.get('territoryTypes')
  const topicsValue = searchParams.get('topics')
  const languageFromUrl = searchParams.get('languages')

  const languageValue = userLanguages.find(item => item.value === languageFromUrl)

  return {
    audience: getAudienceFromUrl(search),
    dateRange: dateRangeValue ? Number(dateRangeValue) : 12,
    languages: languageValue,
    ...(categoriesValue && { categories: categoriesValue }),
    ...(territoryTypesValue && { territoryTypes: territoryTypesValue }),
    ...(topicsValue && { topics: topicsValue }),
  }
}
